export const getExportColumnsViewItems = (report, api) => {
    return {
        name: 'Columns',
        values: [...api.internalApi.getReportService().GetReportColumnScopeShortDescription(report)],
    };
};
